export const PAGE_KEY = 'talent-admin-succession-coverage';
